import { post, read } from '@/utils/request';
import { request } from 'umi';
import type {
  IUserInfo,
  FeishuLoginResp,
  ThirdPartyLoginType,
  ThirdPartyLoginResp,
} from '@/types/user';

async function queryCurrent() {
  return read<IUserInfo>('user/user_info', undefined, '获取登录状态失败');
}

async function login(data: { email: string; password: string }) {
  const { email, password } = data;
  return post<IUserInfo>('user/login', { username: email, password }, '登录失败');
}

async function feishuLogin(data: { code: string }) {
  return request<FeishuLoginResp>('/api/ka_admin/user/feishu_login', {
    method: 'POST',
    data,
  });
}

async function fetchThirdPartyLogin(data: { code: string; type: ThirdPartyLoginType }) {
  return post<ThirdPartyLoginResp>('user/third_login/', data);
}

async function logout() {
  return read<IUserInfo>('user/logout', undefined, '退出登录失败');
}

export type IRegisterInfo = {
  email: string;
  password: string;
  bfUserId: string;
  rePassword: string;
  confirmPassword: string;
  group: string | number | string[] | number[];
};

type IAkmsRegister = {
  username: string;
  bfUserId: string;
  password: string;
  rePassword: string;
  groupId: number;
};

async function register(params: IRegisterInfo) {
  const { email, password, bfUserId, rePassword, group } = params;
  const akmsParams: IAkmsRegister = {
    username: email,
    password,
    bfUserId,
    rePassword,
    groupId: group as number,
  };
  return post('user/register', akmsParams, '注册新用户失败');
}

export { register, login, feishuLogin, logout, queryCurrent, fetchThirdPartyLogin };
